import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private userNameSubject = new BehaviorSubject<string>(localStorage.getItem('userName') || '');
    userName$ = this.userNameSubject.asObservable();

    setUserName(newUserName: string) {
        localStorage.setItem('userName', newUserName);
        this.userNameSubject.next(newUserName);
    }
}